var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"parameters-list"},[_c('div',{staticClass:"parameters-list__heading"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('ctx.parameters.title')))])])]),_c('PParametersList',{attrs:{"sections":_vm.sections}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }